export const achievementsData = [
  {
    title: "Unilever Business Challenge",
    status: "Second Runner Up",
    subTitle:
      "A business case study and campaign design competition, organized by Unilever Sri Lanka as a part of Unilever global business challenge"
  },
  {
    title: "Arimac Futurecast",
    status: "Winners",
    subTitle: "A business ideathon organized by Arimac Sri Lanka"
  },
  {
    title: "Innovate FPGA by Intel and Terasic",
    status: "Regional Finalists",
    subTitle:
      "An international FPGA based project development competition organized by Intel and Terasic"
  }
];
